// import React, { useContext, useEffect, useState } from "react";
// import { FaHandPointer } from "react-icons/fa";
// import { flushSync } from "react-dom";
// import { useNavigate } from "react-router-dom";
// import Frame from "../../assets/images/Frame.png";
// import { FilterContext } from "../../context/Filter";
// import Filteraccordion from "../../components/accordion/Filteraccordion";
// import { fetchDataTable } from "./Arnkpi";

// const Arntable = ({ id }) => {
//     const {
//         superArn,
//         parArn,
//         setArn,
//         childArn,
//         setChildArn,
//         accountName,
//         isGoldenArn,
//         isFilterReady,
//     } = useContext(FilterContext);

//     const [childData, setChildData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [selectedArn, setSelectedArn] = useState(null);
//     const { open } = useContext(FilterContext); // true if sidebar is open

//     const navigate = useNavigate();

//     // ✅ Fetch child data when id changes
//     useEffect(() => {
//         const getChildData = async () => {
//             setLoading(true);
//             try {
//                 const payload = { parArn: id };
//                 const data = await fetchDataTable(payload);

//                 const safeData = Array.isArray(data) ? data : [];
//                 setChildData(safeData);

//                 if (safeData.length > 0) {
//                     setSelectedArn(safeData[0]);
//                 } else {
//                     setSelectedArn(null);
//                 }
//             } catch (error) {
//                 console.error("Error fetching child data:", error);
//                 setChildData([]);
//                 setSelectedArn(null);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         if (id) getChildData();
//     }, [id]);

//     return (
//         <>
//             {/* Main Content - 2 Column Layout for Table */}
//             <div className="grid grid-cols-1 lg:grid-cols-12">

//                 {/* Left Column - Child ARN List */}
//                 <div className="lg:col-span-8">
//                     <div className="bg-white rounded-lg shadow-sm">
//                         <div className="border-b border-gray-200 px-6 py-1">
//                             <div className="flex justify-between items-center">
//                                 <h2 className="text-lg font-semibold text-blue-800">
//                                     Child ARN Details
//                                 </h2>
//                                 <Filteraccordion absolute={""} />
//                             </div>
//                         </div>

//                         <div className="max-h-[290px] overflow-y-auto">
//                             {loading ? (
//                                 <div className="flex justify-center items-center py-2">
//                                     <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
//                                 </div>
//                             ) : childData.length > 0 ? (
//                                 <div className="overflow-x-auto">
//                                     <table className="table-auto w-full border-collapse">
//                                         <thead className="bg-gradient-to-r from-blue-600 to-blue-400 text-white sticky top-0 z-10">
//                                             <tr>
//                                                 <th className="p-3 px-3 border border-blue-900 text-left">#</th>
//                                                 <th className="p-3 px-3 border border-blue-900 text-left">Child Arn</th>
//                                                 <th className="p-3 px-3 border border-blue-900 text-left">Account Name</th>
//                                                 <th className="p-3 border border-blue-900 text-left">KA Code</th>
//                                                 <th className="p-3 px-9 border border-blue-900 text-left">Vehicle Count</th>
//                                                 <th className="p-3 border border-blue-900 text-center">Action</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {childData.map((item, index) => {
//                                                 const isSelected = selectedArn?.ACCNT_ARN === item.ACCNT_ARN;

//                                                 return (
//                                                     <tr
//                                                         key={index}
//                                                         className={`text-[13px] hover:bg-gray-50 cursor-pointer transition-colors ${isSelected ? 'bg-blue-50 border-blue-200' : ''
//                                                             }`}
//                                                         onClick={() => setSelectedArn(item)}
//                                                     >
//                                                         <td className="p-3 border border-gray-200">{index + 1}</td>
//                                                         <td className="p-3 border border-gray-200 font-medium text-blue-600">
//                                                             {item.ACCNT_ARN || "N/A"}
//                                                         </td>
//                                                         <td className="p-3 border border-gray-200">
//                                                             {item.ACCNT_NAME || "N/A"}
//                                                         </td>
//                                                         <td className="p-3 border border-gray-200">
//                                                             {item.ACCNT_LOCATION || "N/A"}
//                                                         </td>
//                                                         <td className="p-3 border border-gray-200 font-medium">
//                                                             {item.Vehicle_count || 0}
//                                                         </td>
//                                                         <td className="p-3 border border-gray-200 text-center">
//                                                             <button
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     // Add navigation logic here if needed
//                                                                 }}
//                                                                 className="text-blue-600 hover:text-blue-800 transition-colors"
//                                                                 title="View Details"
//                                                             >
//                                                                 <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                                                                     <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
//                                                                 </svg>
//                                                             </button>
//                                                         </td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             ) : (
//                                 <div className="text-center py-8 text-gray-500">
//                                     No Data Found
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>

//                 {/* Right Column - Selected ARN Details */}
//                 <div className="lg:col-span-4">
//                     <div className="bg-white rounded-lg shadow-sm">
//                         <div className="border-b border-gray-200 px-6 py-1">
//                             <h2 className="text-lg font-semibold text-blue-800">
//                                 Selected ARN Details
//                             </h2>
//                         </div>

//                         <div className="p-6">
//                             {selectedArn ? (
//                                 <div className="space-y-2">
//                                     {/* ARN */}
//                                     <div className="flex items-center justify-between  border-b border-gray-100">
//                                         <div className="flex items-center gap-3">
//                                             <div className="bg-purple-100 p-2 rounded-lg">
//                                                 <span className="text-purple-600 font-bold text-sm">ID</span>
//                                             </div>
//                                             <span className=" text-xs text-gray-600">ARN</span>
//                                         </div>
//                                         <span className="font-medium text-xs text-gray-900">{selectedArn.ACCNT_ARN || "N/A"}</span>
//                                     </div>

//                                     {/* Account Name */}
//                                     <div className="flex items-center justify-between  border-b border-gray-100">
//                                         <div className="flex items-center gap-3">
//                                             <div className="bg-gray-100 p-2 rounded-lg">
//                                                 <svg className="w-4 h-4 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
//                                                     <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
//                                                 </svg>
//                                             </div>
//                                             <span className=" text-xs text-gray-600">Account Name</span>
//                                         </div>
//                                         <span className="font-medium text-gray-900 text-right text-xs max-w-[150px] ">
//                                             {selectedArn.ACCNT_NAME || "N/A"}
//                                         </span>
//                                     </div>

//                                     {/* KA Code */}
//                                     <div className="flex items-center justify-between border-b border-gray-100">
//                                         <div className="flex items-center gap-3">
//                                             <div className="bg-yellow-100 p-2 rounded-lg">
//                                                 <svg className="w-4 h-4 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
//                                                     <path fillRule="evenodd" d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9zM13.73 21a2 2 0 01-3.46 0" clipRule="evenodd" />
//                                                 </svg>
//                                             </div>
//                                             <span className="text-gray-600 text-xs">KA Code</span>
//                                         </div>
//                                         <span className="font-medium text-xs text-gray-900">{selectedArn.ACCNT_LOCATION || "N/A"}</span>
//                                     </div>

//                                     {/* Vehicle Count */}
//                                     <div className="flex items-center justify-between border-b border-gray-100">
//                                         <div className="flex items-center gap-3">
//                                             <div className="bg-orange-100 p-2 rounded-lg">
//                                                 <svg className="w-4 h-4 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
//                                                     <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM2 10v5a2 2 0 002 2h1a1 1 0 001-1v-1h8v1a1 1 0 001 1h1a2 2 0 002-2v-5H2zm2.5 1a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm8 0a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z" clipRule="evenodd" />
//                                                 </svg>
//                                             </div>
//                                             <span className="text-gray-600 text-xs">Vehicle Count</span>
//                                         </div>
//                                         <span className="font-medium text-gray-900 text-xs">{selectedArn.Vehicle_count || 0}</span>
//                                     </div>

//                                     {/* Additional Info Section */}
//                                     <div className="mt-2 border-t border-gray-200">
//                                         <h4 className="text-sm font-medium text-gray-900 mb-3">Additional Information</h4>
//                                         <div className="space-y-2 text-sm text-gray-600">
//                                             <p>• Selected from {childData.length} total records</p>
//                                             <p>• Last updated: {new Date().toLocaleDateString()}</p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ) : (
//                                 <div className="text-center py-2">
//                                     <div className="bg-gray-100 p-4 rounded-lg ">
//                                         <svg className="w-8 h-8 text-gray-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//                                         </svg>
//                                     </div>
//                                     <p className="text-gray-500">Select a Child ARN to view details</p>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Arntable;
import React, { useContext, useEffect, useState } from "react";
import { FaHandPointer } from "react-icons/fa";
import { flushSync } from "react-dom";
import { useNavigate } from "react-router-dom";
import Frame from "../../assets/images/Frame.png";
import { FilterContext } from "../../context/Filter";
import Filteraccordion from "../../components/accordion/Filteraccordion";
import { fetchDataTable } from "./Arnkpi";

const Arntable = ({ id }) => {
    const {
        superArn,
        parArn,
        setArn,
        childArn,
        setChildArn,
        accountName,
        isGoldenArn,
        isFilterReady,
    } = useContext(FilterContext);

    const [childData, setChildData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedArn, setSelectedArn] = useState(null);
    const { open } = useContext(FilterContext); // true if sidebar is open

    const navigate = useNavigate();

    // ✅ Fetch child data when id changes OR clear data when id is empty
    useEffect(() => {
        // If id is empty/falsy, clear the data
        if (!id) {
            setChildData([]);
            setSelectedArn(null);
            setLoading(false);
            return;
        }

        const getChildData = async () => {
            setLoading(true);
            try {
                const payload = { parArn: id };
                const data = await fetchDataTable(payload);

                const safeData = Array.isArray(data) ? data : [];
                setChildData(safeData);

                if (safeData.length > 0) {
                    setSelectedArn(safeData[0]);
                } else {
                    setSelectedArn(null);
                }
            } catch (error) {
                console.error("Error fetching child data:", error);
                setChildData([]);
                setSelectedArn(null);
            } finally {
                setLoading(false);
            }
        };

        getChildData();
    }, [id]);

    return (
        <>
            {/* Main Content - 2 Column Layout for Table */}
            <div className="grid grid-cols-1 lg:grid-cols-12">

                {/* Left Column - Child ARN List */}
                <div className="lg:col-span-8">
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="border-b border-gray-200 px-6 py-1">
                            <div className="flex justify-between items-center">
                                <h2 className="text-lg font-semibold text-blue-800">
                                    Child ARN Details
                                </h2>
                                <Filteraccordion absolute={""} />
                            </div>
                        </div>

                        <div className="max-h-[290px] overflow-y-auto">
                            {loading ? (
                                <div className="flex justify-center items-center py-2">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                                </div>
                            ) : childData.length > 0 ? (
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full border-collapse">
                                        <thead className="bg-gradient-to-r from-blue-600 to-blue-400 text-white sticky top-0 z-10">
                                            <tr>
                                                <th className="p-3 px-3 border border-blue-900 text-left">#</th>
                                                <th className="p-3 px-3 border border-blue-900 text-left">Child Arn</th>
                                                <th className="p-3 px-3 border border-blue-900 text-left">Account Name</th>
                                                <th className="p-3 border border-blue-900 text-left">KA Code</th>
                                                <th className="p-3 px-9 border border-blue-900 text-left">Vehicle Count</th>
                                                <th className="p-3 border border-blue-900 text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {childData.map((item, index) => {
                                                const isSelected = selectedArn?.ACCNT_ARN === item.ACCNT_ARN;

                                                return (
                                                    <tr
                                                        key={index}
                                                        className={`text-[13px] hover:bg-gray-50 cursor-pointer transition-colors ${isSelected ? 'bg-blue-50 border-blue-200' : ''
                                                            }`}
                                                        onClick={() => setSelectedArn(item)}
                                                    >
                                                        <td className="p-3 border border-gray-200">{index + 1}</td>
                                                        <td className="p-3 border border-gray-200 font-medium text-blue-600">
                                                            {item.ACCNT_ARN || "N/A"}
                                                        </td>
                                                        <td className="p-3 border border-gray-200">
                                                            {item.ACCNT_NAME || "N/A"}
                                                        </td>
                                                        <td className="p-3 border border-gray-200">
                                                            {item.ACCNT_LOCATION || "N/A"}
                                                        </td>
                                                        <td className="p-3 border border-gray-200 font-medium">
                                                            {item.Vehicle_count || 0}
                                                        </td>
                                                        <td className="p-3 border border-gray-200 text-center">
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    // Add navigation logic here if needed
                                                                }}
                                                                className="text-blue-600 hover:text-blue-800 transition-colors"
                                                                title="View Details"
                                                            >
                                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                                                </svg>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="text-center py-8 text-gray-500">
                                    No Data Found
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Right Column - Selected ARN Details */}
                <div className="lg:col-span-4">
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="border-b border-gray-200 px-6 py-1">
                            <h2 className="text-lg font-semibold text-blue-800">
                                Selected ARN Details
                            </h2>
                        </div>

                        <div className="p-6">
                            {selectedArn ? (
                                <div className="space-y-2">
                                    {/* ARN */}
                                    <div className="flex items-center justify-between  border-b border-gray-100">
                                        <div className="flex items-center gap-3">
                                            <div className="bg-purple-100 p-2 rounded-lg">
                                                <span className="text-purple-600 font-bold text-sm">ID</span>
                                            </div>
                                            <span className=" text-xs text-gray-600">ARN</span>
                                        </div>
                                        <span className="font-medium text-xs text-gray-900">{selectedArn.ACCNT_ARN || "N/A"}</span>
                                    </div>

                                    {/* Account Name */}
                                    <div className="flex items-center justify-between  border-b border-gray-100">
                                        <div className="flex items-center gap-3">
                                            <div className="bg-gray-100 p-2 rounded-lg">
                                                <svg className="w-4 h-4 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <span className=" text-xs text-gray-600">Account Name</span>
                                        </div>
                                        <span className="font-medium text-gray-900 text-right text-xs max-w-[150px] ">
                                            {selectedArn.ACCNT_NAME || "N/A"}
                                        </span>
                                    </div>

                                    {/* KA Code */}
                                    <div className="flex items-center justify-between border-b border-gray-100">
                                        <div className="flex items-center gap-3">
                                            <div className="bg-yellow-100 p-2 rounded-lg">
                                                <svg className="w-4 h-4 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9zM13.73 21a2 2 0 01-3.46 0" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <span className="text-gray-600 text-xs">KA Code</span>
                                        </div>
                                        <span className="font-medium text-xs text-gray-900">{selectedArn.ACCNT_LOCATION || "N/A"}</span>
                                    </div>

                                    {/* Vehicle Count */}
                                    <div className="flex items-center justify-between border-b border-gray-100">
                                        <div className="flex items-center gap-3">
                                            <div className="bg-orange-100 p-2 rounded-lg">
                                                <svg className="w-4 h-4 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM2 10v5a2 2 0 002 2h1a1 1 0 001-1v-1h8v1a1 1 0 001 1h1a2 2 0 002-2v-5H2zm2.5 1a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm8 0a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <span className="text-gray-600 text-xs">Vehicle Count</span>
                                        </div>
                                        <span className="font-medium text-gray-900 text-xs">{selectedArn.Vehicle_count || 0}</span>
                                    </div>

                                    {/* Additional Info Section */}
                                    <div className="mt-2 border-t border-gray-200">
                                        <h4 className="text-sm font-medium text-gray-900 mb-3">Additional Information</h4>
                                        <div className="space-y-2 text-sm text-gray-600">
                                            <p>• Selected from {childData.length} total records</p>
                                            <p>• Last updated: {new Date().toLocaleDateString()}</p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center py-2">
                                    <div className="bg-gray-100 p-4 rounded-lg ">
                                        <svg className="w-8 h-8 text-gray-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                        </svg>
                                    </div>
                                    <p className="text-gray-500">Select a Child ARN to view details</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Arntable;